import { render } from "./SortSwitch.vue?vue&type=template&id=1c01c066"
import script from "./SortSwitch.vue?vue&type=script&lang=js"
export * from "./SortSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__